// extracted by mini-css-extract-plugin
export default {"root":"Markdown__root___xxV0u"};